// Pure, i18n-free helpers for the «موسم البولة» festival skin (P2-A). No BE data
// dependency — both derive purely from the run's own startAt/endAt window, so
// they work day one on the existing /poola-deals/current contract.
//
// All timestamps are epoch ms and MUST already be server-offset-adjusted by the
// caller (see PoolaRunHeader's adjustedTargetMs pattern) — these functions never
// touch Date.now()/clock skew themselves, which keeps them trivially unit-testable.

const DAY_MS = 24 * 60 * 60 * 1000;

// Escalating urgency thresholds — "remaining time until the run's endAt", lower
// bound inclusive. A 2–5 day festival window (per the FE plan) makes 48h/24h/6h
// a sensible closingSoon → lastDay → lastHours escalation.
export const FESTIVAL_URGENCY_CLOSING_SOON_MS = 48 * 60 * 60 * 1000;
export const FESTIVAL_URGENCY_LAST_DAY_MS = 24 * 60 * 60 * 1000;
export const FESTIVAL_URGENCY_LAST_HOURS_MS = 6 * 60 * 60 * 1000;

/**
 * Day {n} of {total} for the festival day-counter chip.
 * @returns {{ day: number, total: number } | null} null when the window is missing/invalid.
 */
export function computeFestivalDayCounter({ startAtMs, endAtMs, nowMs }) {
  if (startAtMs == null || endAtMs == null || endAtMs <= startAtMs) return null;
  const total = Math.max(1, Math.ceil((endAtMs - startAtMs) / DAY_MS));
  const dayIndex = Math.floor((nowMs - startAtMs) / DAY_MS) + 1;
  return { day: Math.min(Math.max(dayIndex, 1), total), total };
}

/**
 * Escalating urgency state as the festival's endAt approaches.
 * @returns {'none' | 'closingSoon' | 'lastDay' | 'lastHours'}
 */
export function computeFestivalUrgency({ endAtMs, nowMs }) {
  if (endAtMs == null) return 'none';
  const remainingMs = endAtMs - nowMs;
  if (remainingMs <= 0) return 'none'; // ended — the countdown UI hides itself
  if (remainingMs <= FESTIVAL_URGENCY_LAST_HOURS_MS) return 'lastHours';
  if (remainingMs <= FESTIVAL_URGENCY_LAST_DAY_MS) return 'lastDay';
  if (remainingMs <= FESTIVAL_URGENCY_CLOSING_SOON_MS) return 'closingSoon';
  return 'none';
}
